module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTPlaWflaWflaWfhaWfhaWf9cVPpbW/pbWflaWfpvbv/r6/////2ysmXaBe4AAAAJdFJOUwDjYLCQcBCPj4hE2HoAAACRSURBVBjTY2DAB9iCJScawTiKM4FACMLmmAkGBWBOJ4QzHcRmmgkFCkAO48xZt2bOXLtyphiQozlz7umVs/bcnDkVyLGcOWvPrtWnV86cDORIzpy5+vSeXTNnTgRygFpn7QFKzJyJzkFRhmJAJMzoSUBOIsxSAXTnMHhC2FPArmaBcBwwPcfAoCw50TQBb8gAAOkEXyoe+hrPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/circles/danger.png
// module id = 1364
// module chunks = 32